import { supabase } from "./client";

export const supabaseAuthProvider = {
  signIn: async (email, password) => {
    return await supabase.auth.signInWithPassword({ email, password });
  },

  signUp: async (email, password, options = {}) => {
    return await supabase.auth.signUp({ email, password, options });
  },

  signOut: async () => {
    return await supabase.auth.signOut();
  },

  getUser: async () => {
    try {
      return await supabase.auth.getUser();
    } catch (error) {
      console.warn("supabase.auth.getUser error:", error);
      return { data: { user: null }, error };
    }
  },

  getSession: async () => {
    try {
      return await supabase.auth.getSession();
    } catch (error) {
      console.warn("supabase.auth.getSession error:", error);
      return { data: { session: null }, error };
    }
  },

  resetPassword: async (email, redirectTo) => {
    return await supabase.auth.resetPasswordForEmail(email, { redirectTo });
  },

  updateUser: async (attributes) => {
    return await supabase.auth.updateUser(attributes);
  },

  setSession: async (accessToken, refreshToken) => {
    try {
      return await supabase.auth.setSession({
        access_token: accessToken,
        refresh_token: refreshToken,
      });
    } catch (error) {
      console.warn("supabase.auth.setSession error:", error);
      return { data: { session: null }, error };
    }
  },

  onAuthStateChange: (callback) => {
    try {
      const { data } = supabase.auth.onAuthStateChange(callback);
      return () => {
        if (data && data.subscription) {
          data.subscription.unsubscribe();
        }
      };
    } catch (error) {
      console.warn("supabase.auth.onAuthStateChange error:", error);
      return () => {};
    }
  },
};
